import "vanilla-match-height";

window.addEventListener("load", () => {
  const elements = document.querySelectorAll('[data-mh]');
  const groups = new Set();

  elements.forEach(el => groups.add(el.getAttribute('data-mh')));

  groups.forEach(group => {
    document.body.matchHeight({
      byRow: false,
      attributeName: 'data-mh',
      targetValue: group,
    });
  });
});